export enum SelectOpenState {
  Blurred,
  Closed,
  Open
}

export const SELECT_BOX_TEST_IDS = {
  root: 'select-box-root',
  input: 'select-box-input',
  optionList: 'select-box-option-list',
  option: (option: string) => `select-box-option-${option}`,
  optionGroup: (group: string) => `select-box-option-group-${group}`,
  skeletonItem: 'select-box-skelton-item',
  noOptions: 'select-box-no-options',
  clearButton: 'select-box-clear-button',
  disabledInfo: 'select-box-disabled-info',
  noneOption: 'select-box-none-option'
}

export const SELECT_BOX_NONE_OPTION_VALUE = '__INTERNAL__noneValue'
export const SELECT_BOX_DEFAULT_MAX_LIST_HEIGHT = 320
